import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  FiUsers,
  FiArrowUpRight,
  FiArrowDownRight,
} from "react-icons/fi";

export default function TicketCards() {
  const cards = [
    {
      title: "Total Tickets",
      value: "2,847",
      percent: "+12.5%",
      iconBg: "#f97316",
      bg: "#f6e9e2",
      border: "#f97316",
      trend: "up",
    },
    {
      title: "Open Tickets",
      value: "342",
      percent: "+8.2%",
      iconBg: "#0f3d3e",
      bg: "#e7eef0",
      border: "#0f3d3e",
      trend: "up",
    },
    {
      title: "Resolved Today",
      value: "128",
      percent: "+15.5%",
      iconBg: "#16a34a",
      bg: "#e8f5ec",
      border: "#16a34a",
      trend: "up",
    },
    {
      title: "Avg Time",
      value: "2.4h",
      percent: "+12.3%",
      iconBg: "#3b82f6",
      bg: "#e8f0fb",
      border: "#3b82f6",
      trend: "up",
    },
    {
      title: "Overdue",
      value: "23",
      percent: "-5.2%",
      iconBg: "#ef4444",
      bg: "#f6dede",
      border: "#ef4444",
      trend: "down",
    },
    {
      title: "Active Agents",
      value: "42",
      percent: "+8.2%",
      iconBg: "#ec4899",
      bg: "#f6e3ec",
      border: "#ec4899",
      trend: "up",
    },
  ];

  return (
    <Row 
      className="g-3  h-100">
      {cards.map((card, i) => (
        <Col  xl={2} lg={4} md={6} sm={6} xs={12} key={i}>
          <div
            style={{
              ...styles.card,
              background: card.bg,
            }}
          >
            {/* ICON */}
            <div
              style={{
                ...styles.iconBox,
                background: card.iconBg,
              }}
            >
              <FiUsers size={18} color="#fff" />
            </div>

            {/* TITLE */}
            <p style={styles.title}>{card.title}</p>

            {/* VALUE */}
            <h2 style={styles.value}>{card.value}</h2>

            {/* BADGE */}
            <div style={styles.badge}>
              <span>{card.percent}</span>

              <div
                style={{
                  ...styles.badgeIcon,
                  background:
                    card.trend === "up" ? "#16a34a" : "#ef4444",
                }}
              >
                {card.trend === "up" ? (
                  <FiArrowUpRight size={14} />
                ) : (
                  <FiArrowDownRight size={14} />
                )}
              </div>
            </div>

            {/* BOTTOM BORDER */}
            <div
              style={{
                ...styles.bottomBorder,
                background: card.border,
              }}
            />
          </div>
        </Col>
      ))}
    </Row>
  );
}

/* EXACT STYLES */
const styles = {
  card: {
    position: "relative",
    borderRadius: 16,
    padding: "18px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  iconBox: {
    width: 50,
    height: 50,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    fontSize: 14,
    color: "#4b5563",
    margin: 0,
  },

  value: {
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
    color: "#1f2937",
  },

  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: "#f3f4f6",
    borderRadius: 999,
    padding: "6px 10px",
    fontSize: 13,
    width: "fit-content",
  },

  badgeIcon: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
  },

  bottomBorder: {
    position: "absolute",
    bottom: 0,
    left: 15,
  width: "83%",
    height: 4,
    Right:19,
    
    borderBottomLeftRadius: 25,
    borderBottomRightRadius: 18,
  },
};